import { Box, Grid } from '@mui/material';

import { DeliverableCard } from '@/components/layout/DeliverableCard/DeliverableCard';
import { useAnalysisActions } from '@/modules/common/CreateNewEntityOrStrategy/hooks/useAnalysisActions';
import {
  CLT_ANALYSIS_V2,
  CRT_ANALYSIS_V2,
  GIFT_ANALYSIS_V2,
  GRAT_ANALYSIS_V2,
} from '@/modules/common/CreateNewEntityOrStrategy/ModelANewStrategyModal.constants';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

export function CreateAnalysisModalBody() {
  const { householdId } = useHouseholdDetailsContext();
  const { handleGratClick, handleGiftingClick, handleCharitableDesignerClick } =
    useAnalysisActions(householdId ?? '');

  return (
    <Box p={2} data-testid="CreateAnalysisModalBody">
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <DeliverableCard
            icon={GIFT_ANALYSIS_V2.icon}
            title={GIFT_ANALYSIS_V2.heading}
            description={GIFT_ANALYSIS_V2.body}
            sizeVariant="large"
            badgeComponent={<Box />}
            onClick={handleGiftingClick}
            dataTestId="GiftDeliverableCard"
          />
        </Grid>
        <Grid item sm={6}>
          <DeliverableCard
            icon={GRAT_ANALYSIS_V2.icon}
            title={GRAT_ANALYSIS_V2.heading}
            description={GRAT_ANALYSIS_V2.body}
            sizeVariant="large"
            badgeComponent={<Box />}
            onClick={handleGratClick}
            dataTestId="GratDeliverableCard"
          />
        </Grid>
        <Grid item sm={6}>
          <DeliverableCard
            icon={CRT_ANALYSIS_V2.icon}
            title={CRT_ANALYSIS_V2.heading}
            description={CRT_ANALYSIS_V2.body}
            sizeVariant="large"
            badgeComponent={<Box />}
            onClick={handleCharitableDesignerClick('crt')}
            dataTestId="CrtDeliverableCard"
          />
        </Grid>
        <Grid item sm={6}>
          <DeliverableCard
            icon={CLT_ANALYSIS_V2.icon}
            title={CLT_ANALYSIS_V2.heading}
            description={CLT_ANALYSIS_V2.body}
            sizeVariant="large"
            badgeComponent={<Box />}
            onClick={handleCharitableDesignerClick('clt')}
            dataTestId="CltDeliverableCard"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
